// extracted by mini-css-extract-plugin
module.exports = {"root":"VendorFilter_root__Y8uMs","title":"VendorFilter_title__v-0e6","vendors":"VendorFilter_vendors__u75-o","reset-button":"VendorFilter_reset-button__48FiA"};